export default "__VITE_ASSET__CoH7GCpR__"